export default {"src":"/_next/static/media/section.e388bbb2.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};